import {IRoutableModule} from '../../router/routing.infra';
import {GuestView} from './guest.view';
import {guestRouteLoader} from './guest.loader';

export default {
    loader: guestRouteLoader,
    Component: GuestView,
    storeAs: 'guestStore'
} as IRoutableModule;
